import React from 'react';
import Table from 'antd/lib/table';

import 'antd/lib/table/style/index.css';
import 'antd/lib/pagination/style/index.css';

const AntTable = props => <Table {...props} />;

export default AntTable;
